import { render, staticRenderFns } from "./paymentCategory.vue?vue&type=template&id=729acc3c&scoped=true"
import script from "./paymentCategory.vue?vue&type=script&lang=ts"
export * from "./paymentCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729acc3c",
  null
  
)

export default component.exports